"use strict";exports.__esModule = true;function findAncestorByClassName(el, className) {
  if (!el || !className) {
    return null;
  }

  var parent = el.parentElement;

  if (!parent) {
    return false;
  }

  if (parent.classList.contains(className)) {
    return parent;
  }

  return findAncestorByClassName(parent, className);
}exports.default =

findAncestorByClassName;module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/findAncestor.js
// module id = 1261
// module chunks = 0